/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { CompositeFilter } from './compositeFilter.schema';
import { GroupDescriptor } from './groupDescriptor.schema';
import { SortDescriptor } from './sortDescriptor.schema';

export const listQueryPageNumberRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const listQueryPageSizeRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const ListQuery = zod.object({
  "pageNumber": zod.union([zod.number(),zod.string().regex(listQueryPageNumberRegExpTwo)]).optional(),
  "pageSize": zod.union([zod.number(),zod.string().regex(listQueryPageSizeRegExpTwo)]).optional(),
  "sorting": zod.array(zod.lazy(() => SortDescriptor)).optional(),
  "grouping": zod.array(zod.lazy(() => GroupDescriptor)).optional(),
  "filter": zod.union([zod.null(),zod.lazy(() => CompositeFilter)]).optional()
});

export type ListQuery = zod.input<typeof ListQuery>;
export type ListQueryOutput = zod.output<typeof ListQuery>;
